import {FC} from 'react'
import {useLocation} from 'react-router-dom'
import queryString from 'query-string'
import {useCheckInvitationConfirmationToken} from 'hooks/api/InvitationConfirmation'
import {Presenter} from './Presenter'

export const Show: FC = () => {
  const {search} = useLocation()
  const {token} = queryString.parse(search)
  const confirmationToken = (Array.isArray(token) ? token[0] : token) ?? undefined
  const {isLoading, isValid, errors} = useCheckInvitationConfirmationToken(confirmationToken)

  return <Presenter isLoading={isLoading} isValid={isValid} errors={errors} token={confirmationToken} />
}
